import { IApplicationContext } from 'shared/types/applicationContext';
import { TApplicationState, TReduxStore } from 'shared/types/redux';
import { createReduxStore } from 'shared/redux';
import { ERuntimeSettings } from '../../../shared/types/runtimeSettings';

export function createApplicationState(context: IApplicationContext): TReduxStore {
  const { config } = context;

  const initialState = config.getStrict<TApplicationState>(ERuntimeSettings.initialState);

  return createReduxStore(context, initialState, true);
}
